enum TipoDocumentoBuscaPacienteEnum {
  CPF = 'CPF',
  RGH = 'RGH',
  CARTEIRINHA = 'CARTEIRINHA',
  NOME = 'NOME',
}

export default TipoDocumentoBuscaPacienteEnum
